// --- START OF FIXED SCRIPT ---

document.addEventListener('DOMContentLoaded', function () {
  // --- START OF NEW, MORE ROBUST FIX ---
  const originalSectionId = window.lightweightProductData.sectionId;
  let sectionContainer = document.getElementById(`shopify-section-quickadd-${originalSectionId}`);
  let sectionId = `quickadd-${originalSectionId}`;

  if (!sectionContainer) {
    sectionContainer = document.getElementById(`shopify-section-${originalSectionId}`);
    sectionId = originalSectionId;
  }

  if (!sectionContainer) {
    console.error(`Lightweight Product: Could not find parent section container for ID: ${originalSectionId}`);
    return;
  }
  // --- END OF NEW FIX ---

  const productData = window.lightweightProductData.product;
  const routes = window.lightweightProductData.routes;
  const variantStrings = window.lightweightProductData.variantStrings || {
      addToCart: 'Add to cart',
      soldOut: 'Sold out',
      unavailable: 'Unavailable'
  };

  const productFormElement = sectionContainer.querySelector(`product-form`);
  const form = sectionContainer.querySelector(`#product-form-${sectionId}`);
  const variantSelectsElement = sectionContainer.querySelector(`variant-selects`);
  const hiddenInput = form ? form.querySelector(`input[name="id"]`) : null;
  const skuElement = sectionContainer.querySelector('.product__sku');
  const priceContainer = sectionContainer.querySelector(`#price-${sectionId}`);
  const submitButton = form ? form.querySelector('[type="submit"]') : null;
  const submitButtonSpan = submitButton ? submitButton.querySelector('span:not(.sold-out-message):not(.loading__spinner)') : null;
  const soldOutMessageElement = submitButton ? submitButton.querySelector('.sold-out-message') : null;
  const imageElement = sectionContainer.querySelector('.product-gallery__image');

  const requiredElements = new Map([
    [productFormElement, 'the <product-form> container (usually in the buy-buttons block)'],
    [form, `the <form> with id #product-form-${sectionId} (usually in the buy-buttons block)`],
    [hiddenInput, 'the hidden input for the variant ID (inside the form)'],
    [priceContainer, `the price container with id #price-${sectionId} (usually in the price block)`],
    [submitButton, 'the <button type="submit"> (usually in the buy-buttons block)'],
    [submitButtonSpan, 'the text span inside the submit button'],
    [soldOutMessageElement, 'the sold-out message span inside the submit button'],
    [imageElement, 'the product image with class .product-gallery__image']
  ]);

  let allElementsFound = true;
  for (const [element, description] of requiredElements.entries()) {
    if (!element) {
      // For variantSelectsElement, it's optional, so we don't treat its absence as a fatal error.
      if (element === variantSelectsElement) continue; 
      console.error(`Lightweight Product (${sectionId}): Could not find required element: ${description}.`);
      allElementsFound = false;
    }
  }

  if (!allElementsFound) {
    console.error(`Lightweight Product (${sectionId}): Aborting script because one or more critical HTML elements are missing. Please check your section blocks in the theme customizer.`);
    return;
  }
  
  if (!productData || !productData.variants) {
      console.error(`Lightweight Product (${sectionId}): Missing product variants in window.lightweightProductData.`);
      return;
  }

  const syncUIWithVariant = (variant) => {
      const defaultImageSrc = productData.featured_media?.preview_image?.src || productData.media?.[0]?.preview_image?.src || '';
      const defaultImageAlt = productData.featured_media?.alt || productData.media?.[0]?.alt || productData.title;

      if (variant) {
          if (hiddenInput.value !== variant.id.toString()) {
              hiddenInput.value = variant.id;
          }

          let newImageUrl = defaultImageSrc;
          let newImageAlt = defaultImageAlt;

          if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
              newImageUrl = variant.featured_media.preview_image.src;
              newImageAlt = variant.featured_media.alt || defaultImageAlt;
          } else if (variant.featured_image && variant.featured_image.src) {
              newImageUrl = variant.featured_image.src;
              newImageAlt = variant.featured_image.alt || defaultImageAlt;
          }

          if (imageElement.src !== newImageUrl && newImageUrl) {
              imageElement.src = '';
              imageElement.src = newImageUrl;
          } else if (!newImageUrl) {
              imageElement.src = '';
          }
          if (imageElement.alt !== newImageAlt) {
              imageElement.alt = newImageAlt;
          }

          if (skuElement) {
              skuElement.textContent = variant.sku || '';
              skuElement.classList.toggle('visibility-hidden', !variant.sku);
          }

          updatePriceDisplay(variant, priceContainer, variantStrings);

          if (!variant.available) {
              submitButton.setAttribute('disabled', 'disabled');
              submitButtonSpan.classList.add('hidden');
              soldOutMessageElement.textContent = variantStrings.soldOut;
              soldOutMessageElement.classList.remove('hidden');
          } else {
              submitButton.removeAttribute('disabled');
              submitButtonSpan.classList.remove('hidden');
              submitButtonSpan.textContent = variantStrings.addToCart;
              soldOutMessageElement.classList.add('hidden');
          }
      } else {
          hiddenInput.value = '';
          submitButton.setAttribute('disabled', 'disabled');
          submitButtonSpan.classList.add('hidden');
          soldOutMessageElement.textContent = variantStrings.unavailable;
          soldOutMessageElement.classList.remove('hidden');

          updatePriceDisplay(null, priceContainer, variantStrings);

          if (imageElement.src !== defaultImageSrc) {
              imageElement.src = '';
              imageElement.src = defaultImageSrc;
          }
          if (imageElement.alt !== defaultImageAlt) {
              imageElement.alt = defaultImageAlt;
          }
      }
  };

  const initialVariantId = hiddenInput.value;
  if (initialVariantId) {
      const initialVariant = productData.variants.find(v => v.id.toString() === initialVariantId);
      syncUIWithVariant(initialVariant);
  } else {
      console.warn(`Lightweight Product (${sectionId}): No initial variant ID found in hidden input.`);
      const firstAvailableVariant = productData.variants.find(v => v.available);
      syncUIWithVariant(firstAvailableVariant || productData.variants[0]);
  }

  if (variantSelectsElement) {
    const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
        if (!event?.data?.target || event.data.target.closest('variant-selects') !== variantSelectsElement) {
            return;
        }
        const currentSelections = Array.from(variantSelectsElement.querySelectorAll('select, fieldset input:checked')).map(input => input.value);
        const newVariant = productData.variants.find(variant => {
            if (variant.options.length !== currentSelections.length) return false;
            return variant.options.every((optionValue, index) => optionValue === currentSelections[index]);
        });
        syncUIWithVariant(newVariant);
    });
  }
});

function updatePriceDisplay(selectedVariant, priceContainer, variantStrings) {
  if (!priceContainer) return;

  const priceBlock = priceContainer.querySelector('.price');
  const soldOutBadge = priceContainer.querySelector('.price__badge-sold-out');

  if (!priceBlock) return;
  
  // --- START OF FIX ---
  // All price formatting and display logic has been removed.
  // This function now only handles the sold out status.
  // --- END OF FIX ---

  // Reset state first
  priceBlock.classList.remove('price--sold-out');
  if (soldOutBadge) soldOutBadge.style.display = 'none';

  if (selectedVariant) {
    // Handle sold out status
      if (!selectedVariant.available) {
          priceBlock.classList.add('price--sold-out');
          if (soldOutBadge) soldOutBadge.style.display = '';
      }
  } else { // No variant selected
      priceBlock.classList.add('price--sold-out');
      if (soldOutBadge) soldOutBadge.style.display = '';
  }
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form) {
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        if (this.cart) this.cart.productId = window.lightweightProductData.product.id;

        const config = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
        };
        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const cartAddUrl = window.lightweightProductData?.routes?.cart_add_url || '/cart/add.js';

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              const submitButtonSpan = this.submitButton.querySelector('span:not(.sold-out-message):not(.loading__spinner)');
              if(submitButtonSpan) submitButtonSpan.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.lightweightProductData?.routes?.cart_url || '/cart';
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                requestAnimationFrame(() => {
                  if (this.cart && typeof this.cart.renderContents === 'function') {
                    this.cart.renderContents(response);
                  }
                });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              requestAnimationFrame(() => {
                if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings?.error || 'Error');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            
            const currentVariantId = this.form?.querySelector('[name=id]')?.value;
            const currentVariant = window.lightweightProductData?.product?.variants.find(v => v.id.toString() === currentVariantId);
            
            if (!this.error && currentVariant?.available) {
                this.submitButton.removeAttribute('aria-disabled');
            } else {
                this.submitButton.setAttribute('aria-disabled', 'true');
            }
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

